import { getPlaceholderImages } from '@common/utils/util';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LookupList, LookupListItem } from '@src/suite/common/data-models/complex-types/lookup-list';
import { MerlinMedia, MerlinState } from '@src/suite/common/store/merlin/models/ai.seach.models';

const selectAiState = createFeatureSelector<MerlinState>('merlinSearchResults');
export const selectPhotos = createSelector(selectAiState, (state: MerlinState) => {
    if (state?.merlinMediaSearch?.executing || state?.merlinMediaSearch?.searchTerm?.generating || !state?.merlinMediaSearch?.photos?.length) {
        return getPlaceholderImages();
    }
    return state?.merlinMediaSearch?.photos;
});

export const selectVideos = createSelector(selectAiState, (state: MerlinState) => state?.merlinMediaSearch?.videos);
export const selectVideoRenditions = createSelector(
    selectVideos,
    (videos: MerlinMedia[]) =>
        videos
            ?.map(
                video =>
                    video?.renditions?.find(rendition => {
                        return rendition.duid === 'vid-360p-preview-bug';
                    })
            )
            .filter(rendition => !!rendition)
);
export const selectMediaSearchExecuting = createSelector(selectAiState, (state: MerlinState) => state?.merlinMediaSearch?.executing);
export const selectGeneratingMediaSearchTerm = createSelector(selectAiState, (state: MerlinState) => state?.merlinMediaSearch?.searchTerm?.generating);
export const selectMediaSearchTerm = createSelector(selectAiState, (state: MerlinState) => state?.merlinMediaSearch?.searchTerm?.searchText);

export const selectEntitySearchExecuting = createSelector(selectAiState, (state: MerlinState) => state?.merlinEntitySearch?.executing);
export const selectHashtagsAsLookupList = createSelector(
    selectAiState,
    (state: MerlinState) => new LookupList(...(state?.merlinEntitySearch?.hashtags || []).map(hashtag => new LookupListItem(hashtag.entity, hashtag.entity)))
);
export const selectPeople = createSelector(selectAiState, (state: MerlinState) => state?.merlinEntitySearch?.people);
export const selectPeopleIds = createSelector(selectAiState, (state: MerlinState) => state?.merlinEntitySearch?.people?.map(person => person.entity));
export const selectPlaces = createSelector(selectAiState, (state: MerlinState) => state?.merlinEntitySearch?.places);
//  new LookupList(...(state?.merlinEntitySearch?.places || []).map(place => new LookupListItem(place.entity, place.entity)))
export const selectPlacesAsLookupList = createSelector(
    selectAiState,
    (state: MerlinState) => new LookupList(...(state?.merlinEntitySearch?.places || []).map(place => new LookupListItem(place.entity, place.entity)))
);
